import { WishListUI } from "./WishListUI";
import { StandardProps } from "../componentMap";
import { useEffect } from "react";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { ensureIsActive } from "../../utils/product/ensureIsActive";
import { ActiveProduct, FeatureFlags, RuntimeConfig } from "../../types/types";

export const EVENT_NAME = "displayedProduct";

export function WishList({
  product,
  runtimeConfig,
  flags,
}: Pick<StandardProps, "product" | "runtimeConfig" | "flags">) {
  const activeProduct = ensureIsActive(product);

  return (
    activeProduct && (
      <ActiveProductWishList
        product={activeProduct}
        runtimeConfig={runtimeConfig}
        flags={flags}
      />
    )
  );
}

function ActiveProductWishList({
  product,
  runtimeConfig,
  flags,
}: {
  product: ActiveProduct;
  runtimeConfig: RuntimeConfig;
  flags: FeatureFlags;
}) {
  const { esiBasepath } = runtimeConfig;

  const { variant, isSelected } = useVariant(product);

  useEffect(() => {
    document.body.dispatchEvent(
      new CustomEvent(EVENT_NAME, {
        detail: {
          productId: product.aliases.pimProductId,
          skuId: variant.aliases.skuId,
        },
      }),
    );
  }, [variant]);

  return (
    <WishListUI
      skuId={variant.aliases.skuId}
      isSkuSelected={isSelected}
      pimProductId={product.aliases.pimProductId}
      isAvailableToOrder={!!variant.availability?.availableToOrder}
      esiSrc={`${esiBasepath}/add-to-wishlist/exclude-cpa.html`}
      flags={flags}
    />
  );
}
